export enum ApplicationFlow {
  Agent = 'Agent',
  Vendor = 'Vendor',
  Pdf = 'Pdf',
  Draft = 'Draft'
}
